module.exports = "https://cdn.realtymogul.com/static/media/icon_cashflow.1c9594e9.svg";